//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'QuickInput',

  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    maxlength: {
      type: String,
      default: 'characters',
    },
    resetScroll: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    inputClicked() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    handleInput(ev) {
      let value = ev.target.value;

      if (
        this.type === 'number' &&
        this.maxlength !== 'characters' &&
        value.length > this.maxlength
      ) {
        value = value.slice(0, this.maxlength);
        ev.target.value = value;
      }
      this.$emit('input', value);
    },
    handleBlur() {
      if (this.resetScroll) {
        setTimeout(() => {
          let scrollTop =
            document.body.scrollTop + document.documentElement.scrollTop;
          window.scrollTo(0, scrollTop);
        }, 40);
      }
    },
  },

  created() {},
};



// WEBPACK FOOTER //
// ./src/components/quickInput/quickInput.vue